import React from 'react';
import { Modal, Form, Input } from 'antd';

interface AddIpModalProps {
    open: boolean;
    loading: boolean;
    onCancel: () => void;
    onSubmit: (values: { ip_address: string, label?: string }) => void;
}

export const AddIpModal: React.FC<AddIpModalProps> = ({
    open,
    loading,
    onCancel,
    onSubmit
}) => {
    const [form] = Form.useForm();

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    const handleOk = () => {
        form.submit();
    };

    return (
        <Modal
            title="Whitelist IP Address"
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item name="ip_address" label="IP Address" rules={[{ required: true, message: 'Valid IP' }]}>
                    <Input placeholder="192.168.1.1" />
                </Form.Item>
                <Form.Item name="label" label="Label (Optional)">
                    <Input placeholder="Office VPN" />
                </Form.Item>
            </Form>
        </Modal>
    );
};
